type FlowFormat = `[${Flow}:${string}]` // [flow:function/api call naming] e.g. [simulation:createProspect]
type CmsFormat = `[CMS:${string}:${string}]` // [CMS:page:function] e.g. [CMS:career:getStaticProps]
type ErrorBoundaryFormat = '[ErrorBoundary]'
type S2SFormat = `[S2S:${string}]` // For server to server errors
type BackendFormat = `[BACKEND:${string}]` // For server to server errors
type ItsmeFormat = `[Itsme:${string}]` // For server to server errors

export type IdentifierFormats =
  | FlowFormat
  | CmsFormat
  | ErrorBoundaryFormat
  | S2SFormat
  | BackendFormat
  | ItsmeFormat
  | `[${string}:${string}]`

export type Logging<T extends IdentifierFormats> = {
  severity?: Severity // default is error
  identifier: T
  error: Error | string
  metaData?: {
    [section: string]: {
      [key: string]: unknown
    }
  }
  criticality?: Criticality
  tags?: Record<string, string>
}

export type LoggingUser = {
  id?: string
  email: string
  name?: string
}

export enum Criticality {
  CRITICAL = 'critical',
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low'
}

export enum Flow {
  SIMULATION = 'simulation',
  REGISTRATION = 'registration',
  COMMON = 'common',
  NOT_FOUND = 'not_found'
}

export enum Severity {
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info'
}
